import PostonData from "../../../../src/components/poston-data.js";
import * as React from 'react';
export default {
  PostonData,
  React
};